import React, {Component} from 'react'
import {Modal, Button, Spin, Table, Row, Col} from 'antd'
import * as PropTypes from 'prop-types'
import {inject, observer} from 'mobx-react'
import {EyeOutlined, RedoOutlined} from '@ant-design/icons'
import CommentsModal from './CommentsModal'
import RulesModal from './RulesModal'
import SQLModal from './SQLModal'
import {withTranslation} from 'react-i18next'

function MinusCircleOutlined() {
  return null
}

MinusCircleOutlined.propTypes = {onClick: PropTypes.func}

@inject('rulesManagementStore')
@observer
class VersionModal extends Component {
  state = {
    commentModalVisible: false,
    versionId: null,
    rulesModalVisible: false,
    SQLModalVisible: false,
    modalType: 'check',
    commentType: null
  }

  handleCheck = versionId => {
    const {ruleType, rulesManagementStore} = this.props

    rulesManagementStore.getVersionDetail({type: ruleType, versionId}).then(res => {
      if (res?.data?.code === 0) {
        ruleType === 'Rule' ? this.setState({rulesModalVisible: true}) : this.setState({SQLModalVisible: true})
      }
    })
  }

  handleCancel = target => {
    this.setState({[target]: false})
  }

  showCommentModal = (type, versionId) => {
    this.setState({commentModalVisible: true, commentType: type, versionId})
  }

  render() {
    const {commentModalVisible, rulesModalVisible, SQLModalVisible, modalType, commentType, versionId} = this.state
    const {versionModalVisible, handleCancel, rulesManagementStore, ruleName, ruleId, t} = this.props
    const {isFetching, versionList} = rulesManagementStore

    return (
      <Spin spinning={isFetching}>
        <Modal title={`${t(`rulesManagement.ruleName`)}: ${ruleName}`} width={1200} visible={versionModalVisible}
               maskClosable={false} destroyOnClose={true} centered onCancel={() => handleCancel('versionModalVisible')}
               footer={null}
        >
          <Row>
            <Col offset={22} style={{textAlign: 'right', marginBottom: '20px'}}>
              <Button type="primary" onClick={() => this.showCommentModal('Record')}>{t(`general.record`)}</Button>
            </Col>
          </Row>
          <Table dataSource={versionList} rowKey="id" pagination={false} style={{marginBottom: '20px'}} scroll={{y: 400}}>
            <Table.Column title={t(`rulesManagement.iD`)} dataIndex="id" key="id" ellipsis={true}/>
            <Table.Column title={t(`rulesManagement.date`)} dataIndex="createTime" key="createTime" ellipsis={true}/>
            <Table.Column title={t(`rulesManagement.user`)} dataIndex="createUser" key="createUser" ellipsis={true}/>
            <Table.Column title={t(`rulesManagement.rollbackId`)} dataIndex="rollbackId" key="rollbackId" ellipsis={true}/>
            <Table.Column title={t(`rulesManagement.comments`)} dataIndex="comments" key="comments" ellipsis={true}/>
            <Table.Column width={100} align="center" title={t(`general.action`)} key="Action" render={(text, record) => {
              return (
                <>
                  <Button type="link" onClick={() => this.handleCheck(record.id)} icon={<EyeOutlined/>} title={t(`general.display`)}/>
                  <Button type="link" onClick={() => this.showCommentModal('Recover', record.id)} icon={<RedoOutlined/>}
                          title={t(`general.rollback`)}/>
                </>
              )
            }}/>
          </Table>
        </Modal>

        {
          commentModalVisible ?
            <CommentsModal modalVisible={commentModalVisible} handleCancel={() => this.setState({commentModalVisible: false})}
                           ruleId={ruleId} type={commentType} versionId={versionId}/> : null
        }
        {
          rulesModalVisible ?
            <RulesModal handleCancel={this.handleCancel} rulesModalVisible rulesModalType={modalType} ruleName={ruleName}/> : null
        }
        {
          SQLModalVisible ?
            <SQLModal handleCancel={this.handleCancel} SQLModalVisible SQLModalType={modalType} ruleName={ruleName}/> : null
        }
      </Spin>
    )
  }
}

export default withTranslation()(VersionModal)
